"use client";

import { c as _c } from "react/compiler-runtime";
import { Icon } from "@iconify/react";
import type { IconifyProps } from "./types";

// ----------------------------------------------------------------------

interface Props {
  icon: IconifyProps;
  // width?: number | string;
  // height?: number | string;
  color?: string;
  className?: string;
}
const Iconify = t0 => {
  const $ = _c(10);
  let icon;
  let other;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      icon,
      color: t1,
      className: t2,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = icon;
    $[2] = other;
    $[3] = t1;
    $[4] = t2;
  } else {
    icon = $[1];
    other = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const color = t1 === undefined ? undefined : t1;
  const className = t2 === undefined ? "" : t2;
  let t3;
  if ($[5] !== className || $[6] !== color || $[7] !== icon || $[8] !== other) {
    t3 = <Icon icon={icon} color={color} className={className} {...other} />;
    $[5] = className;
    $[6] = color;
    $[7] = icon;
    $[8] = other;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
Iconify.displayName = "Iconify";
export default Iconify;